import React from 'react'
import './Hero.css'
import Header from './Header'
import HeroImage from '../assets/hero_image.png';
import HeartImage from '../assets/heart.png';
import CaloritImage from '../assets/calories.png';
import HeroImageBack from '../assets/hero_image_back.png';
import {motion} from 'framer-motion'
import NumberCounter from 'number-counter';
export default function Hero() {
  const transition={type:"spring",duration:3};
  const mobile =window.innerWidth<=768?true:false;
  return (
    <div className="Hero" style={{backgroundColor:"#464D53"}}>
      <div className="blur hero-blur"></div>
        <div className="left-h">
            <div className="head">
                <Header/>
            </div>
           

            <div className="The-Best-ad">
            <motion.div
            initial={{left:mobile?"165px":"238px"}}
            whileInView={{left:"8px"}}
            transition={transition}
            >
            </motion.div>
            <span>the best fitness club in the town</span>
            </div>

            <div className='hero-text'>
              <div>
            <span className="stroke-text">Shape </span>
            <span>Your</span>
            </div>
            <div>
              <span>ideal body</span>
            </div>
            
            <div>
              <span>
                In here we will help you to shape and build your ideal live up your life to fullest 
              </span>
             
            </div>
            </div>
            <div className="figures">
              <div>
                <span>
                 <NumberCounter end={140} start={100} delay='4'preFix="+"/>
                </span>
                <span>expert coachs</span>
              </div>
              <div>
              <span>
            <NumberCounter end={978} start={800} delay='4'preFix="+"/>

              </span>
              <span>members joined</span>
              </div>
              <div>
              <span>
               <NumberCounter end={50} start={0} delay='4'preFix="+"/>

              </span>
              <span>fitness programs</span>
              </div>
            </div>
            <div className="buttons">
              <button className="btn">Get Started</button>
              <button className="btn">Learn More  </button>
            </div>
        </div>
        <div className="right-h">
          <button className="btn">
            Join Now
          </button>

          <motion.div 
          initial={{right:"7rem",top:"-2px"}}
          whileInView={{right:"10rem"}}
          transition={transition}
          className="heart-rate">
            <img src={HeartImage} alt=""/>
          <span>Heart Rate</span>
          <span>116 bpm</span>
          </motion.div>

          <img src={HeroImage} alt="" className="HeroImage"/>
          <motion.img src={HeroImageBack} alt="" 
          initial={{right:"37rem"}}
          whileInView={{right:"18rem"}}
          transition={transition}
          className='HeroImageBack' />

          <motion.div 
          initial={{right:"37rem"}}
          whileInView={{right:"30rem"}}
          transition={transition}
          className="calories">
            <img src={CaloritImage} alt="" />
            <div>
            <span>Calories Burned</span>
            <span>220 kcal</span>
            </div>
           
          </motion.div>
        </div>
    </div>
  )
}
